// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowListModal-cls1_lA5","cls2":"BulkFollowListModal-cls2_CWH BulkFollowListModal-cls1_lA5"};